import {useAppSelector} from "../../../../redux/hooks";
import {getTeamMemberNameById} from "../../../../redux/team-members/team-members.selectors";


export const useTeamMemberNameLogic = (teamMemberId: number): string =>
  useAppSelector((store) => getTeamMemberNameById(store, teamMemberId));
